
export const tokens = {
  'rox-dark-green': '#253837',
  'rox-dark-green-press': '#1b2a29',
  'rox-off-white': '#f5f5f5',
  'rox-lilac': '#b2a1ff',
  'rox-lilac-hover': '#9e8afa',
  'rox-lilac-ink': '#6f5bd8',
  'rox-orange': '#ea6f39',
  'rox-orange-ink': '#b4491d',

  'neutral-900': '#1b2a29',
  'neutral-800': '#253837',
  'neutral-700': '#3c5150',
  'neutral-600': '#56706e',
  'neutral-500': '#7c918f',
  'neutral-400': '#a6b4b2',
  'neutral-300': '#c9d2d1',
  'neutral-200': '#e2e7e6',
  'neutral-100': '#eff2f1',
  'neutral-50': '#f5f5f5',

  'bg-canvas': '#f5f5f5',
  'bg-surface': '#ffffff',
  'bg-sunken': '#eff2f1',
  'border-default': '#c9d2d1',
  'border-control': '#7c918f',
  'fg-default': '#253837',
  'fg-secondary': '#56706e',
  'fg-tertiary': '#5f7472',
  'fg-on-dark': '#f5f5f5',
  link: '#6f5bd8',
  'focus-ring': '#6f5bd8',

  'fg-on-fill': '#ffffff',

  'tag-bg': '#eff2f1',
  'tag-ink': '#56706e',

  'status-approved': '#2f7d63',
  'status-under-review': '#6f5bd8',
  'status-pending': '#ea6f39',
  'status-declined': '#a93b22',

  'badge-approved-border': '#c3e0d6',
  'badge-review-border': '#dcd4ff',
  'badge-watch-border': '#f9dacb',
  'badge-declined-border': '#f8e5df',

  'dec-watch-bg': '#fdede5',
  'dec-watch-bd': '#f9dacb',
  'dec-watch-ink': '#b4491d',

  'badge-approved-bg': '#e4f1ec',
  'badge-approved-ink': '#1f5c48',
  'badge-review-bg': '#efebff',
  'badge-review-ink': '#5b45c4',
  'badge-watch-bg': '#fdede5',
  'badge-watch-ink': '#b4491d',
  'badge-declined-bg': '#fbe9e4',
  'badge-declined-ink': '#8c2f1b',

  'rox-lilac-tint': '#efebff',

  'chart-1': '#6f5bd8',
  'chart-2': '#2f7d63',
  'chart-3': '#ea6f39',
  'chart-grid': '#e2e7e6',
  'chart-axis': '#5f7472',

  'rail-item-active-bg': 'rgba(178, 161, 255, 0.16)',
  'rail-item-hover-bg': '#2f3d3c',
  'rail-label': '#b9c6c4',
  'rail-label-active': '#ffffff',
  'rail-eyebrow': '#a5adac',

  'btn-primary-hover': '#1f2f2e',
  'btn-accent-hover': '#c2b4ff',
  'btn-accent-press': '#cfc5ff',
  'btn-orange-hover': '#d65c27',
  'btn-danger-hover': '#8c2f1b',

  'font-sans': "'Gilmer', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
  't-h1': '28px',
  't-page-title': '22px',
  't-h2': '20px',
  't-h3': '16px',
  't-body-lg': '17px',
  't-body': '15px',
  't-body-sm': '14px',
  't-caption': '13px',
  't-weight-light': '300',
  't-weight-regular': '400',
  't-weight-medium': '500',
  't-weight-bold': '700',
  't-weight-heavy': '900',
  't-tracking-tight': '-0.01em',
  't-tracking-eyebrow': '0.08em',

  'sh-1': '0 1px 2px rgba(27, 42, 41, 0.06), 0 2px 8px rgba(27, 42, 41, 0.04)',
  'sh-2': '0 4px 12px rgba(27, 42, 41, 0.10)',
  'sh-3': '0 8px 28px rgba(27, 42, 41, 0.12)',

  'radius-sm': '4px',
  'radius-md': '8px',
  'radius-lg': '16px',
  'radius-pill': '999px',

  'ease': 'cubic-bezier(0.2, 0.7, 0.2, 1)',
  'dur-hover': '120ms',
  'dur-toggle': '200ms',
  'dur-pop': '320ms',
}

export const token = name => {
  const v = tokens[name]
  if (v === undefined) throw new Error(`Unknown design token: --${name}`)
  return v
}

export const px = name => parseFloat(token(name))

export default tokens
